export function getTextPathShape(angle: number) {
  if (angle < 0) {
    const once = -angle;
    const twice = 2 * -angle;

    return `M 0, 0 m ${once}, ${twice} a ${once}, ${once} 0 1, 0 0, ${twice} a ${once}, ${once} 0 1, 0 0, -${twice}`;
  }

  const twice = 2 * angle;
  return `M 0, 0 m ${angle}, 0 a ${angle}, ${angle} 0 1, 1 0, -${twice} a ${angle}, ${angle} 0 1, 1 0, ${twice}`;
}
